export enum Colors {
  primary='#011FBB',
  secondary='#01A6C7',
  primaryGradient='#4C69FF',
  white='#FFF',
  gray='#F9F9F9',
  lightGray='#C8CACF',
  textGray='#767B87',
  darkBlue='#4d87ff',
  lightBlue='#f6f8ff',
  linkBlue='#007bff',
  disabledText='#9A9FAB',
}

export enum Texts {
  enterYourPrompt='Enter a prompt here',
  dialogTitle='Ask Lily',
  New='New',
  Copy='Copy',
  GoodResponse='Good Response',
  BadResponse='Bad Response',
  Regenerate='Regenerate',
  importantInfo='Enlil AI can make mistakes. Verify important information.',
  helpText='How can I help you today?',
  usedPrompts='Commonly used prompts',
}
